import script from "./CloseButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./CloseButton.vue?vue&type=script&lang=ts&setup=true"

import "./CloseButton.vue?vue&type=style&index=0&id=2d8fdb04&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d8fdb04"]])

export default __exports__